import { render } from "./Notas.vue?vue&type=template&id=644cdda7&scoped=true"
import script from "./Notas.vue?vue&type=script&lang=js"
export * from "./Notas.vue?vue&type=script&lang=js"

import "../../main.css?vue&type=style&index=0&lang=css&external"
import "./Notas.vue?vue&type=style&index=1&id=644cdda7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644cdda7"]])

export default __exports__